import { InputList } from 'framework/form';
import SkillsTemplate from '../shared/SkillsTemplate/SkillsTemplate';
import { useAsyncValue } from 'framework/utils';
import useEmployeeSkillsNamesService from '../useEmployeeSkillsNamesService';
import { SKILL_STATUS } from '../constants';

const EmployeeSkillForm = () => {
  const { searchAll } = useEmployeeSkillsNamesService();

  const value = useAsyncValue(searchAll);

  return (
    <InputList
      addText="Add skill"
      inputTemplate={SkillsTemplate}
      maxFields={value?.length || 0}
      defaultValue={{
        skillName: '',
        status: SKILL_STATUS.TRAINING,
      }}
      source="skills"
    />
  );
};

export default EmployeeSkillForm;
